<template>
  <div class="full">
    <div class="py-4 flex gap-4 center">
      <div class="f-col gap-3 center">
        <div class="c-white text-center rounded-full bg-black flex h-8 w-8 center title-2">
          <vf-icon v-if="auth.loggedIn" class="c-white" name="check" size="md" />
          <span v-else>1</span>
        </div>
        {{ state === 'sign-up' ? $t.eventSignUp.joinXPLRPass : $t.registerDialog.signIn }}
      </div>
      <vf-icon dir="right" name="chevron" size="lg" />
      <div class="f-col gap-3 center">
        <span
          class="text-center rounded-full flex h-8 w-8 center title-2"
          :class="!auth.loggedIn ? 'bg-white b b-black c-black' : 'c-white bg-black'"
        >2</span>
        {{ $t.eventSignUp.joinEvent }}
      </div>
    </div>
    <div v-if="auth.loggedIn">
      <form-event-sign-up-join-event :content />
    </div>
    <template v-else-if="state === 'sign-in'">
      <h2 class="mb-4 subtitle-1">
        {{ $t.registerDialog.signIn }}
      </h2>
      <p class="text-xs">
        {{ $t.requiredField }}
      </p>
      <form-sign-in compact form-location="modal:single:event:none" />
      <div>
        <p class="mt-6">
          {{ $t.notAMember }}
        </p>
        <vf-button class="mt-4" variant="tertiary" @click="state = 'sign-up'">
          {{ $t.createAccount }}
        </vf-button>
      </div>
    </template>
    <template v-else>
      <h2 class="mb-4 subtitle-1">
        {{ $t.signUp }}
      </h2>
      <p class="mb-2 mt-6">
        {{ $t.registerDialog.alreadyAMember }}
        <base-button class="underlined" @click="state = 'sign-in'">
          {{ $t.registerDialog.signIn }}
        </base-button>
      </p>
      <form-sign-up disable-sign-in inside-dialog />
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { EventSignUp } from '#types/components/cms/event-signup'

defineProps<{
  content: EventSignUp
}>()

const state = ref('sign-in')

const auth = useAuthStore()
</script>
